import React from "react";
import ReactDOM from "react-dom";
import { DataTableExportConfiguration, Column, ExportConfigurationDefault, ColumnValue, ColumnSingleValue } from './dataTable.common';
import { tableToCsv } from "./excelHelper";

export class CsvButton<T> extends React.PureComponent<{
  storagekey?: string;
  className?: string;
  style?: React.CSSProperties;
  config?: DataTableExportConfiguration;
  data: T[],
  columns: Column<T>[]
}> {
  downloadAnchorElement: HTMLAnchorElement;

  onExportClick = () => {
    const config = { ...ExportConfigurationDefault, ...this.props.config }
    const anchorElement = ReactDOM.findDOMNode(this.downloadAnchorElement)!;
    const data = this.getTableData(config);
    return tableToCsv(anchorElement, data, config.includeHeaders!, config.columnDelimiter!, config.decimalSeparator!);
  };

  getCsvFileName = () => {
    let baseName = this.props.storagekey || "table";
    const date = new Date();
    return `${baseName}-${date.getFullYear()}-${date.getMonth()}-${date.getDate()}-${date.getHours()}-${date.getMinutes()}.csv`;
  };

  private getTableData = (config: DataTableExportConfiguration) => {
    const columns = this.props.columns.filter(x => x.canExport());
    const data = this.props.data;

    let rows: string[][] = []

    if (config.includeHeaders) {
      let headers: string[] = []
      for (const i in columns) {
        const h = this.getNodeText(columns[i].getHeader(data), config);
        headers.push(h || `column ${i}`);
      }

      rows.push([...headers]);
    }
    for (const row of data) {
      let buffer: string[] = []
      for (const column of columns) {
        let result: string | null | undefined = "";
        if (column.getExportTemplate()) {
          const t = column.getExportTemplate()!;
          const v = t(row);
          result = this.getExportValue(v, config);

        } else {
          const node = column.getCell(row);
          result = this.getNodeText(node, config);
        }

        buffer.push(result ?? "")
      }
      rows.push([...buffer])
    }

    return rows;
  }

  private replaceDecimalSimbol = (value: string, simbol: string) => {
    const v = value.replace(/[\.,]/g, simbol);
    return v;
  }

  private getExportValue = (value: ColumnValue, config: DataTableExportConfiguration) => {
    if (Array.isArray(value)) {
      const c = value as any;
      return c.map((x: ColumnSingleValue) => this.getExportValue(x, config)).join(" ")
    } else {
      if (typeof (value) == "number") {
        return this.replaceDecimalSimbol(value.toString(), config.decimalSeparator!);
      }
      return value.toString();
    }
  }

  private getNodeText = (node: React.ReactNode, config: DataTableExportConfiguration): string | null | undefined => {
    if (typeof node === "string") {
      return node.toString();
    } else if (typeof node === "number") {
      return this.replaceDecimalSimbol(node.toString(), config.decimalSeparator!);
    } else {
      const el = node as React.ReactElement;
      if (el != null && el.props.children) {
        if (Array.isArray(el.props.children)) {
          let buffer: string[] = []
          for (const child of el.props.children) {
            const result = this.getNodeText(child, config);
            if (result)
              buffer.push(result);
          }

          return buffer.join(" ");
        } else {
          return this.getNodeText(el.props.children, config)
        }
      }

      return null;
    }
  }

  render() {
    return (
      <a
        href="#"
        className={this.props.className}
        title="esporta su excel"
        download={this.getCsvFileName()}
        ref={a => (this.downloadAnchorElement = a!)}
        onClick={this.onExportClick}
        style={this.props.style}
      >
        <i className="fas fa-file-csv" />
      </a>
    );
  }
}
